import { GenericFailure, CommonSuccess } from '@playq/services-shared';

import { UseMutationOptionsExtended, useEitherMutation } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { logOutFromSessionKey } from './constants';

export const useLogOutFromSession = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, number>
) =>
  useEitherMutation((id: number) => services2.userSessionsService.logOutFrom(id), {
    mutationKey: logOutFromSessionKey,
    ...options,
    meta: {
      onErrorMessage: (err: GenericFailure) => ({
        message: `Error occured while trying to log out from session: ${err.message}`,
        log: true,
      }),
      ...options?.meta,
    },
  });
